var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"oval","opacity":"0.4","x":"99","y":"1","width":"131","height":"98","rx":"49","transform":"rotate(90 99 1)","stroke":"url(#paint0_linear_1631_23333)","strokeWidth":"2","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_1631_23333","x1":"126.521","y1":"92.2983","x2":"220.296","y2":"-7.20263","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#C4F1F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#0BC5EA","key":1})]))]);
}

Oval.defaultProps = {"width":"100","height":"133","viewBox":"0 0 100 133","fill":"none"};

module.exports = Oval;

Oval.default = Oval;
